import { mainApiAxios as axios } from '@/plugins/axios'

export default {

    listNotes(taskId) {
        return axios.get(`notes?activityInstanceId=${taskId}`)
    },

    updateNote(noteId, noteObj) {
        return axios.post(`notes/update/${noteId}`, noteObj)
    },

    addNote(noteObj) {
        return axios.post('notes', noteObj)
    },

    deleteNote(noteId) {
        return axios.post(`notes/delete/${noteId}`)
    }
}